module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "browse-page"
    }
  }, [(_vm.pageId === 'games' && _vm.isLoggedIn) ? _c('div', {
    staticClass: "option-row"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/CreateNewGameProject"
    }
  }, [_vm._v("Create a Game Project")])], 1) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "browse-results"
    }
  }, [(_vm.filterControls) ? _c('section', {
    attrs: {
      "id": "browse-filter-controls"
    }
  }, [(_vm.filterControls.showOptions.length > 0) ? _c('div', {
    staticClass: "filter-control"
  }, [_c('label', [_vm._v("Show")]), _vm._v(" "), _c('ul', _vm._l((_vm.filterControls.showOptions), function(option) {
    return _c('li', {
      class: {
        selected: option.selected
      },
      on: {
        "click": function($event) {
          _vm.setOption(option.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.filterControls.filterOptions.length > 0) ? _c('div', {
    staticClass: "filter-control"
  }, [_c('label', [_vm._v("Filter By")]), _vm._v(" "), _c('ul', _vm._l((_vm.filterControls.filterOptions), function(option) {
    return _c('li', {
      class: {
        selected: option.selected
      },
      on: {
        "click": function($event) {
          _vm.setOption(option.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showRecruitingOptions && _vm.filterControls.recruitingOptions.length > 0) ? _c('div', {
    staticClass: "filter-control"
  }, [_c('label', [_vm._v("Recruiting")]), _vm._v(" "), _c('ul', _vm._l((_vm.filterControls.recruitingOptions), function(option) {
    return _c('li', {
      class: {
        selected: option.selected
      },
      on: {
        "click": function($event) {
          _vm.setOption(option.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.filterControls.sortOptions.length > 0) ? _c('div', {
    staticClass: "filter-control"
  }, [_c('label', [_vm._v("Sort By")]), _vm._v(" "), _c('ul', _vm._l((_vm.filterControls.sortOptions), function(option) {
    return _c('li', {
      class: {
        selected: option.selected
      },
      on: {
        "click": function($event) {
          _vm.setOption(option.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.filterControls.showSkills) ? [(_vm.skillFilterId === 0) ? [_c('div', {
    staticClass: "filter-control"
  }, [_c('label', [_vm._v("Skill")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enteredSkill),
      expression: "enteredSkill"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search for Skill Tags..."
    },
    domProps: {
      "value": (_vm.enteredSkill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enteredSkill = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.enteredSkill.length > 0) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.enteredSkill = ''
      }
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "filter-control"
  }, [(_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("\n                            No matching tags... Search by skill name, or type a category\n                            to see all entries. Categories: Art, Software, Development, Engine, Writing, Production, Testing\n                        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "skills"
  }, _vm._l((_vm.matchingSkills), function(skill) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.setSkillId(skill.id)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(skill.skill) + "\n                            ")])
  }))])] : _vm._e(), _vm._v(" "), (_vm.skillFilterId > 0) ? [_c('div', {
    staticClass: "filter-control"
  }, [_c('label', [_vm._v("Skill")]), _vm._v(" "), _c('ul', {
    staticClass: "skills"
  }, [_c('li', {
    staticClass: "selected",
    on: {
      "click": function($event) {
        _vm.setSkillId(0)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  }), _vm._v(_vm._s(_vm.skillList[_vm.skillFilterId].skill) + "\n                            ")])])])] : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.browseResults.length > 0 && !_vm.isFetching) ? _c('section', {
    staticClass: "pagination",
    attrs: {
      "id": "browse-pagination-top"
    }
  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
    attrs: {
      "max-page": _vm.resultsPageTotal,
      "current-page": _vm.resultsPageCurrent,
      "spread": 5
    },
    on: {
      "switchToPage": _vm.switchToResultsPage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "browse-items"
    }
  }, [(_vm.isFetching) ? _c('div', [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching) ? _c('div', [(_vm.browseResults.length > 0) ? [_vm._l((_vm.browseResults), function(result) {
    return (_vm.pageId === 'developers') ? _c('browsePageDeveloperItem', {
      attrs: {
        "details": result
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.browseResults), function(result) {
    return (_vm.pageId === 'games') ? _c('browsePageGameItem', {
      attrs: {
        "details": result
      }
    }) : _vm._e()
  })] : _vm._e(), _vm._v(" "), (_vm.browseResults.length === 0) ? [_c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v("\n                        Sorry, no matching results were found.\n                        "), (_vm.pageId === 'games') ? [_vm._v("Skill tags are still new for Game Projects. Try removing the\n                            Skill filter.\n                        ")] : _vm._e()], 2)] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.browseResults.length > 0 && !_vm.isFetching) ? _c('section', {
    staticClass: "pagination",
    attrs: {
      "id": "browse-pagination-bottom"
    }
  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
    attrs: {
      "max-page": _vm.resultsPageTotal,
      "current-page": _vm.resultsPageCurrent,
      "spread": 5
    },
    on: {
      "switchToPage": _vm.switchToResultsPage
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-edae640a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Browse/BrowsePage.vue
// module id = 924
// module chunks = 2